/**
 * Helper function to get the seller's profile URL
 * The profile URL depends on the type of seller
 */
export const getProfileUrl = (
  /** Profile Id for the URL to be returned  */
  profileId: string
): {
  url: string
  linkProps: { target?: string; rel?: string }
} => {
  /** TODO (POST_MVP):
   * - If profile is from an autos dealer -> Generate internal professional page
   * - If profile is from a RE Professional (comFree) -> Generate internal professional page & return websiteURL if any
   * */
  /** Internal profile URL */
  return { url: `/o-profile/${profileId}/listings/1`, linkProps: {} }
}
